export const locale = {
  lang: 'fr-CA',
  data: {
    NAV: {
      APPLICATIONS: 'Applications',
      DASHBOARD: {
        TITLE: 'Tableau de bord',
        TITLE1: 'Tableau de bord 1',
        TITLE2: 'Tableau de bord 2',
        TITLE3: 'Tableau de bord 3',
        TITLE4: 'Tableau de bord 4',
        TITLE_OPERATIONS: 'Opérations',
        TITLE_PERFORMANCE: 'Performance',
      },
      OPERATIONS: {
        TITLE: 'Tableau de bord détaillé',
      },
      DASHBOARD_DETAILED_JUL: {
        TITLE: 'Tableau de bord',
      },
      PRODUCTS: {
        TITLE: 'Produits',
      },
      CLIENTS: {
        TITLE: 'Clients et entreprises',
      },
      VENUES: {
        TITLE: 'Lieux',
      },
      ROOMS: {
        TITLE: 'Salles',
      },
      ORDERS: {
        TITLE: 'Commandes',
      },
      REPORTS: {
        TITLE: 'Rapports',
      },
      SETTINGS: {
        TITLE: 'Configuration',
      },
      SUPPORT: {
        TITLE: 'Support',
      },
      UPGRADE: {
        TITLE: 'Mise à niveau',
      },
      UPGRADE_FEATURES: {
        TITLE: 'Fonctionnalités',
      },
      UPGRADE_SUBMISSIONS: {
        TITLE: 'Soumission Web',
      },
      UPGRADE_AUTOMATIONS: {
        TITLE: 'Automatisations',
      },
      UPGRADE_INTEGRATIONS: {
        TITLE: 'Intégrations',
      },
      UPGRADE_AI: {
        TITLE: 'IA',
      },
      UPGRADE_REQUEST: {
        TITLE: 'Commander',
      },
      CONTACT: {
        TITLE: 'Demande de ticket',
      },
      KB: {
        TITLE: 'Base de connaissance',
      },
      PROFILE: {
        TITLE: 'Profil',
      },
      ORGANIZATION: {
        TITLE: 'Organization',
      },
      EMPLOYEES: {
        TITLE: 'Employés',
      },

      TODO: {
        TITLE: 'Tâches',
      },
      TEST: {
        TITLE: 'Page Test (dev)',
      },
      ROOM_MANAGEMENT: {
        TITLE: 'Gestion des salles',
      },

      ADMIN: 'Admin',
      GOD: 'God',
      GOD_LOCAL_STORAGE: {
        TITLE: 'Local storage',
      },
      GOD_REPORTS: {
        TITLE: 'Rapports',
      },
      GOD_EMAILS: {
        TITLE: 'Emails',
      },
      GOD_IMPERSONATION: {
        TITLE: 'Impersonation',
      },
      DEV: 'Dev',
      MODULES: 'Modules',
      MODULE_1: {
        TITLE: 'Module 1',
      },
      MODULE_2: {
        TITLE: 'Module 2',
      },
      FUNCTIONS: {
        TITLE: 'Fonctions',
      },
      MATERIALS: {
        TITLE: 'Matériels',
      },
      MANAGEMENT: {
        TITLE: 'Gestion',
      },
      HELP_CENTER: {
        TITLE: "Centre d'aide",
      },
      DOCUMENTATION: {
        TITLE: 'Base de connaissance',
      },
      RELEASE_NOTES: {
        TITLE: 'Note de mise à jour',
      },
      SHOPS: {
        TITLE: 'Boutiques',
      },
      SUBMISSIONS: {
        TITLE: 'Soumissions Web',
      },
      SENT_EMAILS: {
        TITLE: 'Courriels envoyés',
      },
      CONGRESSES: {
        TITLE: 'Congrès',
      },
      UPSALE: {
        TITLE: 'Vente incitative',
      },
      PLATFORM: {
        TITLE: 'Plate-forme',
      },
      GTPHOTO_ANDROID: {
        TITLE: 'GT Photo Android',
      },
      GTPHOTO_IOS: {
        TITLE: 'GT Photo iOS',
      },
      RMS_MAGIC_LINK: {
        TITLE: 'Recette / Inventaire',
      },
      RMS_MAGIC_LINK_LIVRAISON: {
        TITLE: 'Livraison',
      },
      ROADMAP_MAGIC_LINK: {
        TITLE: 'Roadmap',
      },
    },
  },
};
